quoteModule.directive('preflight', function () {

    return {
        templateUrl: 'app/modules/quote/directives/preflight-directive.html',
        replace: true,
        restrict: 'E'
    };
});